import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider as AppThemeProvider, useAppTheme } from "@/layout/ThemeContext";
import { PrinceSizeProvider, setTheme as princeSetTheme, type PrinceTheme } from "@conuti-das/prince-ui";

import { router } from "@/router";
import { ensureAuth } from "@/lib/auth";
// prince-ui: tokens first, then component styles, then app CSS.
import "@conuti-das/prince-ui-tokens/tokens.css";
import "@conuti-das/prince-ui/styles.css";
import "./styles/global.css";

/**
 * Wendet das gewählte prince-ui-Theme ("light" | "dark" | "cu-light" | "cu-dark")
 * imperativ über
 * setTheme() auf <html data-theme> an. Liegt innerhalb von AppThemeProvider,
 * um dessen Context via useAppTheme() zu lesen.
 */
function PrinceThemeBridge({ children }: { children: React.ReactNode }) {
  const { theme } = useAppTheme();

  useEffect(() => {
    princeSetTheme(theme as PrinceTheme);
  }, [theme]);

  return <>{children}</>;
}

// Keycloak-Login VOR dem ersten Render. ensureAuth() löst entweder mit
// gültiger Session auf oder redirected die Seite zum Keycloak-Login --
// in beiden Fällen rendert die App erst nach erfolgreichem Login.
ensureAuth().then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <AppThemeProvider>
        {/* PrinceThemeBridge must be inside AppThemeProvider to read its context */}
        <PrinceThemeBridge>
          {/* prince-ui: compact form controls app-wide (s = compact, like studio) */}
          <PrinceSizeProvider size="s">
              <RouterProvider router={router} />
            </PrinceSizeProvider>
        </PrinceThemeBridge>
      </AppThemeProvider>
    </React.StrictMode>,
  );
});
